import { Box, CardMedia } from '@mui/material'
import settings from 'settings'
import { useImgWithFallback, ImgWithFallbackInit } from 'features/common/hooks/useImgWithFallback'

interface MapThumbnailProps {
  title: string
  url?: string
}

function MapThumbnail({ url, title }: MapThumbnailProps) {
  const DEFAULT_THUMBNAIL = `${settings.publicUrl}/maps/loading_map.png`
  const thumbnailUrl = useImgWithFallback(url, DEFAULT_THUMBNAIL, ImgWithFallbackInit.Fallback)

  return (
    <Box overflow="hidden">
      <CardMedia image={thumbnailUrl} title={title} sx={{ height: (theme) => theme.spacing(20.5) }} component="img" />
    </Box>
  )
}

export default MapThumbnail
